module.exports = __webpack_public_path__ + "img/icon03_highlight.7f6c968.png";